import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import reportWebVitals from "./reportWebVitals"
import Forbin from "./Components/Forbin"
import { createTheme, ThemeProvider } from "@mui/material"
import { AdminProvider } from "./AdminContext"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
const theme = createTheme({
  typography: {
    fontFamily: "'Montserrat'",
    fontWeightRegular: 500,
  },
})
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AdminProvider>
        <Forbin />
      </AdminProvider>
    </ThemeProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
